import React from 'react';
import { useIntercom } from '../../hooks/use_intercom';
import { OmniaButton } from '../omnia_button/omnia_button';
import chat from './chat.svg';
import email from './email.svg';

interface CustomerServiceProps {
  className?: string;
}

export const CustomerService = (props: CustomerServiceProps) => {
  const { className } = props;

  const { show } = useIntercom();

  return (
    <div className={className}>
      <div
        className={`bg-white rounded-2xl flex flex-col px-4 mb-6 text-left shadow-sm max-w-[320px]`}
      >
        <div className="flex items-center pt-4 pb-3">
          <div>
            <img src={chat} alt="chat" width={48} />
          </div>
          <div className="flex-1  px-3">
            <p className="text-link-blue font-bold text-[15px]">Live Chat</p>
          </div>
          <div>
            <OmniaButton kind="secondary" size="xl" onPress={show}>
              Chat Now
            </OmniaButton>
          </div>
        </div>
        <div className="flex items-center pb-4 pt-3 border-t">
          <div>
            <img src={email} alt="email" width={45} />
          </div>
          <div className="flex-1 px-3">
            <p className="text-link-blue text-[15px] font-bold">Email</p>
            <p className="text-[#9B9B9B] text-[11px] leading-tight">
              Response usually in 1&nbsp;hour
            </p>
          </div>
          <div>
            <OmniaButton
              kind="tertiary"
              size="xl"
              onPress={() => {
                window.location.href = 'mailto:hello@omniafishing.com';
              }}
            >
              Email Us
            </OmniaButton>
          </div>
        </div>
      </div>
      <p className="text-[11px]">
        <strong>Hours:</strong> Monday-Friday 9 AM to 5 PM Central
      </p>
    </div>
  );
};
